var exports = {
  "Vf": "MessageReactions.module__reactionsGrid___VlB3WT",
  "RW": "MessageReactions.module__reactionContainer___VlB3WT",
  "sU": "MessageReactions.module__reactionButton___VlB3WT",
  "I1": "MessageReactions.module__reactionMe___VlB3WT",
  "iX": "MessageReactions.module__reactionInner___VlB3WT",
  "Zg": "MessageReactions.module__emoji___VlB3WT",
  "Ps": "MessageReactions.module__countWrapper___VlB3WT",
  "NE": "MessageReactions.module__countTick___VlB3WT",
  "lG": "MessageReactions.module__reactionContainerDisabled___VlB3WT",
  "II": "MessageReactions.module__reactionButtonDisabled___VlB3WT",
  "Go": "MessageReactions.module__reactionPickerButton___VlB3WT",
  "SD": "MessageReactions.module__reactionPickerButtonActive___VlB3WT",
};

module.exports = exports;
